<template>
  <header class="header">
    <div class="container">
      <div class="header__wrapper">
        <div class="header__left">
          <div class="header__dropdown" ref="dropdownRef">
            <img src="@icons/menu-button.svg" @click="setSwitcherVisible(!isSwitcherVisible)" class="header__dropdown-button" :class="[{ active: isSwitcherVisible }]" alt="menu-button"/>
            <div
                class="header__dropdown-menu"
                :class="[{active: isSwitcherVisible}]"
            >
              <ul class="header__dropdown-menu-wrapper">
                <li
                    v-for="category in categories"
                    :key="category.node.uuid"
                    @click="redirect(category.node.slug)"
                    class="header__dropdown-item"
                    :class="[{ active: activeCategory === category.node.slug }]"
                >
                  {{ category.node.name }}
                </li>
              </ul>
            </div>
          </div>
          <router-link class="header__logo" :to="translations.i18nRoute({ name: 'home' })">
            <img src="@images/logo-header.png" alt="logo">
          </router-link>

        </div>

          <svg class="header__menu" @click="isMenuActive = !isMenuActive" width="40px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="none">
            <path fill="currentColor" fill-rule="evenodd"
                  d="M18 5a1 1 0 100-2H2a1 1 0 000 2h16zm0 4a1 1 0 100-2h-8a1 1 0 100 2h8zm1 3a1 1 0 01-1 1H2a1 1 0 110-2h16a1 1 0 011 1zm-1 5a1 1 0 100-2h-8a1 1 0 100 2h8z"/>
          </svg>
        <div class="header__right">
          <div class="header__actions" v-if="user">
            <router-link :to="translations.i18nRoute({ name: 'wishlist' })" class="header__actions-item">
              <el-badge :value="productsInWishlistQuantity">
                <img src="@icons/wishlistIcon.svg" :alt="t('buttons.wishlist')">
              </el-badge>
              {{ t('buttons.wishlist') }}
            </router-link>
            <router-link :to="translations.i18nRoute({ name: 'cart' })" class="header__actions-item">
              <el-badge :value="productsInCartQuantity">
                <img src="@icons/cartIcon.svg" :alt="t('buttons.cart')">
              </el-badge>
              {{ t('buttons.cart') }}
            </router-link>
            <router-link :to="translations.i18nRoute({ name: 'profile-settings' })" class="header__actions-item">
              <img src="@icons/userIcon.svg" :alt="t('profile.title')">
              {{ t('profile.title') }}
            </router-link>
          </div>
          <div v-else class="header__actions-login">
            <router-link :to="translations.i18nRoute({ name: 'login' })" class="header__auth">
              <p>{{ t('header.Sign-in') }}</p>
            </router-link>
            <router-link :to="translations.i18nRoute({ name: 'register' })" class="header__auth">
              <p>{{ t('header.Sign-up') }}</p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <BaseMenu
        :is-active="isMenuActive"
        @close-modal="handleCloseModal"
    />
  </header>
</template>

<script setup>
import translations from "@/core/helpers/translations.js";
import {computed, ref} from "vue";
import {useCategoryStore} from "@/stores/category.js";
import {useRoute, useRouter} from "vue-router";
import {onClickOutside} from "@vueuse/core";
import {useI18n} from "vue-i18n";
import {useAuthStore} from "@/stores/auth.js";
import {useCartStore} from "@/stores/cart.js";
import {useWishlistStore} from "@/stores/wishlist.js";
import BaseMenu from "@/components/base/base-menu.vue";
const categoryStore = useCategoryStore()
const authStore = useAuthStore()
const cartStore = useCartStore()
const wishlistStore = useWishlistStore()
const router = useRouter()
const route = useRoute()
const {t} = useI18n()

const categories = computed(() => categoryStore.categories)

const activeCategory = computed(() => {
  return route.query.categoriesSlugs
})
const user = computed(() => {
  return authStore.user
})
const userBalance = computed(() => {
  return authStore.user ? authStore.user.balance.amount : 0
})

const productsInCartQuantity = computed(() => {
  let count = 0
  cartStore.currentOrder.orderProducts?.edges.forEach((el) => {
    count = count + el.node.quantity
  })

  return count
})
const productsInWishlistQuantity = computed(() => {
  return wishlistStore.wishlist.products ? wishlistStore.wishlist.products.edges.length : 0
})

const redirect = (categorySlug) => {
  router.push({
    name: 'market',
    query: {
      categoriesSlugs: categorySlug
    },
    params: {
      locale: localStorage.getItem('digitgiftcode-user-locale') || 'en-gb'
    }
  })
  isSwitcherVisible.value = false
}

const isSwitcherVisible = ref(false)
const setSwitcherVisible = (state) => {
  isSwitcherVisible.value = state
}

const dropdownRef = ref(null)
onClickOutside(dropdownRef, () => isSwitcherVisible.value = false)

const isMenuActive = ref(false)
const handleCloseModal = () => {
  isMenuActive.value = false;
}
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  width: 100vw;
  z-index: 1000;
  top: 15px;

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 11px 40px;
    border-radius: 100px;
    background-color: #FFFFFF;
    box-shadow: 0px -1px 8px 0px rgba(0, 0, 0, 0.25), 0px 2px 4px 0px rgba(0, 4, 53, 0.25);

  }

  &__left {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  &__right {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  &__dropdown {
    position: relative;

    &-button {
      cursor: pointer;
      transition: 0.2s;

      & rect {
        transition: 0.2s;
      }
      & line {
        transition: 0.2s;
      }

      &.active {
        & rect {
          fill: #3b3b3b;
        }

        & path {
          fill: #161616;
        }
      }

      @include hover {
        & rect {
          fill: #3b3b3b;
        }

        & path {
          fill: #161616;
        }
      }
    }

    &-menu {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 200%;
      border-radius: 10px;
      box-shadow: 0 4px 8.2px 0 rgba(0, 0, 0, 0.10);
      backdrop-filter: blur(6px);
      display: grid;
      grid-template-rows: 0fr;
      transition: grid-template-rows 0.2s ease;
      overflow: hidden;

      &-wrapper {
        display: flex;
        flex-direction: column;
      }

      &.active {
        grid-template-rows: 1fr;

        @media (max-width: 750px) {
          left: 200%;
        }
      }

      & > * {
        min-height: 0;
      }
    }

    &-item {
      cursor: pointer;
      transition: 0.2s;
      padding: 5px 15px;
      background-color: #b7b7b7;

      color: #222;
      font-size: 16px;
      font-weight: 500;
      line-height: 26px;

      @include hover {
        background-color: white;
        color: #161616;
      }

      &.active {
        background-color: white;
        color: #DD6196;
      }
    }
  }

  &__logo {
    & img {
      width: 140px;
    }
  }

  &__menu {
    flex-shrink: 0;
    cursor: pointer;
    transition: 0.2s;
    color: #3b3b3b;
    display: none;

    @include hover {
      color: #d0b300;
    }
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 15px;

    &-login{
      display: flex;
      align-items: center;
      gap: 2px;

      & a{
        &:first-child{
          background-color: #5A5BC8;
          padding: 7px 13px;
          border-radius: 30px 0 0 30px;
        }
        &:last-child{
          background-color: #5A5BC8;
          padding: 7px 13px;
          border-radius: 0 30px 30px 0;
        }
      }
    }

    &-item {
      cursor: pointer;
      padding-right: 15px;
      border-right: 1px solid #D9D9D9;
      display: flex;
      align-items: center;
      gap: 5px;
      transition: 0.2s;

      color: black;
      font-weight: 700;
      line-height: 18px;

      @include hover {
        color: #6e6e6e;
      }

      &:last-child {
        border-right: none;
        padding-right: 0;
      }
    }
  }

  &__auth {
    display: flex;
    align-items: center;
    gap: 5px;

    & p {
      transition: 0.2s;
      color: #FFFFFF;
      font-size: 16px;
      font-weight: 700;
      line-height: 18px;
    }
  }
}

@media (max-width: 1300px) {
  .header {
    &__wrapper {
      gap: 50px;
    }

    &__left {
      width: 100%;
    }

    &__form {
      margin-left: 0;
      width: 100%;

      &-input {
        padding-inline: 40px 10px;
      }
    }
  }
}

@media (max-width: 1100px) {
  .header {

    &__wrapper {
      position: relative;
    }
    &__menu {
      display: block;
      position: absolute;
      right: 40px;
    }

    &__actions {
      display: none;
    }

    &__auth {
      display: none;
    }
  }
}

@media (max-width: 650px) {
  .header {
    &__wrapper {
      gap: 5px;
    }

    &__form {
      display: none;
    }
  }
}
</style>